import React from 'react';
var TextOverflow = function TextOverflow(_ref) {
  var className = _ref.className,
    maxWidth = _ref.maxWidth,
    type = _ref.type,
    children = _ref.children;
  var style = {
    maxWidth: maxWidth,
    textOverflow: type,
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, children);
};
TextOverflow.defaultProps = {
  className: null,
  type: 'ellipsis'
};
export default TextOverflow;